import { fetchWrapper } from "../utils/fetch-wrapper";

const espacesService = {
  getAll,
  getById,
  post,
  update,
  delete: _delete,
  count,
};

function getAll(env_client_id: any = "") {
  const queryParams: Record<string, any> = {};

  if (env_client_id !== "") {
    queryParams.env_client_id = env_client_id;
  }
  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");

  return fetchWrapper.get(`espaces/?${queryString}`);
}

function getById(id) {
  return fetchWrapper.get(`espaces/${id}`);
}

function post(data) {
  return fetchWrapper.post("espaces/", data);
}

function update(id, params) {
  return fetchWrapper.put(`espaces/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`espaces/${id}`);
}

function count() {
  return fetchWrapper.get(`espaces/count`);
}

export default espacesService;
